enum ModalSize {
  extraSmall,
  small,
  medium,
  large,
  fullScreen,
}

export default ModalSize;
